import script from "./ClientesDependentes.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientesDependentes.vue?vue&type=script&lang=ts&setup=true"

import "./ClientesDependentes.vue?vue&type=style&index=0&id=cbe36764&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbe36764"]])

export default __exports__